import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Snackbar from 'material-ui/Snackbar'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { ThemeProvider } from 'styled-components'

import { Grid } from '../../../components/Grid'
import Copyright from '../../../components/Copyright'
import FullPageLoading from '../../../components/FullPageLoading'
import WelcomeHeader from './WelcomeHeader'
import { WelcomePageWrapper, CenterCol } from './styled-components'

class NonAuthenticatedLayout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    message: PropTypes.string,
    duration: PropTypes.number,
    isOpen: PropTypes.bool.isRequired,
    hideNotification: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    theme: PropTypes.object.isRequired
  }

  state = {}

  handleSnackbarRequestClose = reason => {
    if (reason === 'timeout') {
      this.props.hideNotification()
    }
  }

  render() {
    const { theme } = this.props

    return (
      <MuiThemeProvider muiTheme={theme}>
        <ThemeProvider theme={theme}>
          <Grid fluid>
            <WelcomePageWrapper>
              <CenterCol
                xs={10}
                xsOffset={1}
                sm={8}
                smOffset={2}
                md={6}
                mdOffset={3}
                lg={4}
                lgOffset={4}>
                <WelcomeHeader />
                {this.props.children}
                <Copyright />
              </CenterCol>
            </WelcomePageWrapper>

            <Snackbar
              message={this.props.message}
              autoHideDuration={this.props.duration}
              open={this.props.isOpen}
              onRequestClose={this.handleSnackbarRequestClose}
              bodyStyle={{
                height: 'auto',
                padding: '10px 15px',
                lineHeight: 1.5,
                whiteSpace: 'pre-line'
              }}
            />

            {this.props.isLoading && <FullPageLoading />}
          </Grid>
        </ThemeProvider>
      </MuiThemeProvider>
    )
  }
}

export default NonAuthenticatedLayout



// WEBPACK FOOTER //
// ./src/layouts/NonAuthenticated/components/index.js